import * as utils from 'common/utils';
import { mapNames } from './constants';

/**
 * Calendar presets for chart time ranges (values must stay stable for API/state).
 */
export const getChartCalendarOptions = t => [
  { text: t('machineDashboard.health.charts.calendar.oneDayShort'), value: 1 },
  { text: t('machineDashboard.health.charts.calendar.sevenDaysShort'), value: 7 },
  { text: t('machineDashboard.health.charts.calendar.thirtyDaysShort'), value: 30 },
  { text: t('machineDashboard.health.charts.calendar.threeMonths'), value: 90 },
  { text: t('machineDashboard.health.charts.calendar.oneYear'), value: 365 },
  { text: t('machineDashboard.health.charts.calendar.all'), value: undefined },
  { text: t('machineDashboard.health.charts.calendar.custom'), value: 'custom' }
];

/** Subset of presets (stable `value`s) for screens that do not show the full range. */
export const getChartCalendarOptionsForValues = (t, values) => {
  const allowed = new Set(values);
  return getChartCalendarOptions(t).filter(x => allowed.has(x.value));
};

/** Waterfall spectrum modal: 30 / 90 / 180 days and All. */
export const getWaterfallCalendarOptions = t => [
  { text: t('machineDashboard.health.charts.calendar.thirtyDaysShort'), value: 30 },
  { text: t('machineDashboard.health.charts.calendar.threeMonths'), value: 90 },
  { text: t('machineDashboard.health.charts.calendar.oneHundredEightyDaysShort'), value: 180 },
  { text: t('machineDashboard.health.charts.calendar.all'), value: undefined }
];

/**
 * Localized display label for vibration/chart feature keys (rms, demod, shaft_speed_1x, …).
 */
export const chartFeatureDisplayName = (t, feature) => {
  if (!feature) return '';
  return t(`machineDashboard.health.charts.featureNames.${feature}`, {
    defaultValue: mapNames[feature] || utils.CapitalizeOnlyFirstLetter(feature)
  });
};

/**
 * Prefer featureNames, then ampTypes, then English mapNames (used by chart option filters).
 *
 * Uses i18next fallback-key array form so only the first existing key resolves and a
 * `missingKey` warning is logged at most once (when none exist). A nested `t()` in the
 * `defaultValue` would be evaluated eagerly and log a spurious `ampTypes` miss even when
 * the `featureNames` key resolves.
 */
export const chartAmpOrFeatureDisplayName = (t, key) => {
  if (!key) return '';
  return t(
    [
      `machineDashboard.health.charts.featureNames.${key}`,
      `machineDashboard.health.charts.ampTypes.${key}`
    ],
    { defaultValue: mapNames[key] || utils.CapitalizeOnlyFirstLetter(key) }
  );
};
